import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getEcommerceShop } from "services/get-ecommerceShop";
import { useWrapRequest } from "utils";
import "components/CustomerAuth/customer-auth.scss";
import { UtmInfo } from "atoms/models";


const CustomerAuth = () => {
    const wrapRequest = useWrapRequest();
    const navigate = useNavigate();

    const WINDOW_LOCATION = "ec:windowLocation";

    useEffect(() => {
        wrapRequest(async () => {
            const hash = window.location.hash;
            if (!hash) return;

            const params = new URLSearchParams(hash.substring(1));
            const token = params.get("id_token");
            if (!token) return;

            localStorage.setItem("msAuthToken", token);

            let utmInfo: UtmInfo | null = null;
            try {
                const utmInfoString = sessionStorage.getItem("utmInfo");
                if (utmInfoString) utmInfo = JSON.parse(utmInfoString);
            } catch (e) {
                console.error("Error parsing utmInfo:", e);
            }

            const responseJson = await getEcommerceShop(
                token,
                sessionStorage.getItem("item"),
                sessionStorage.getItem("type"),
                utmInfo
            );

            const targetUrl = responseJson["_links"]?.[WINDOW_LOCATION]?.href;
            if (!targetUrl) return;

            targetUrl.startsWith("https") ? (window.location.href = targetUrl) : navigate(targetUrl);
        });
        // eslint-disable-next-line
    }, [navigate]);


    return (
        <div className='customer-auth-container'>
            <h2 className='section-loading-message'>Loading customer summary...</h2>
        </div>
    );
}

export default CustomerAuth;